import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const Sidebar = observer(({ auditLogs, tourNotes, customerNotes }) => (
  <div className="column">
    <section className="ransom-section">
      <p>
        <strong>Tour Audit Log</strong>
      </p>
      <div className="section-content">
        {auditLogs.length === 0 ? (
          "No logs..."
        ) : (
          <ul>
            {auditLogs.map(auditLog => (
              <li key={auditLog}>{auditLog}</li>
            ))}
          </ul>
        )}
      </div>
    </section>
    <section className="ransom-section">
      <p>
        <strong>Tour Notes</strong>
      </p>
      <div className="section-content">{tourNotes || "No tour notes..."}</div>
    </section>
    <section className="ransom-section">
      <p>
        <strong>Customer Notes</strong>
      </p>
      <div className="section-content">{customerNotes || "No customer notes..."}</div>
    </section>
  </div>
));

Sidebar.propTypes = {
  auditLogs: PropTypes.arrayOf(PropTypes.string.isRequired),
  tourNotes: PropTypes.string,
  customerNotes: PropTypes.string,
};

Sidebar.defaultProps = {
  auditLogs: [],
};

export default Sidebar;
